import { render, staticRenderFns } from "./IntlFooter.vue?vue&type=template&id=62fe0500&scoped=true"
import script from "./IntlFooter.vue?vue&type=script&lang=js"
export * from "./IntlFooter.vue?vue&type=script&lang=js"
import style0 from "./IntlFooter.vue?vue&type=style&index=0&id=62fe0500&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62fe0500",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62fe0500')) {
      api.createRecord('62fe0500', component.options)
    } else {
      api.reload('62fe0500', component.options)
    }
    module.hot.accept("./IntlFooter.vue?vue&type=template&id=62fe0500&scoped=true", function () {
      api.rerender('62fe0500', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/login/international/components/IntlFooter.vue"
export default component.exports